import { StyledGrid } from "components/simple";
import React from "react";
import { Title, Subtitle, Paragraph } from "./styled";
import { ReactComponent as ErrorImage } from "assets/Error.svg";

const Maintenance: React.FC = () => {
  return (
    <>
      <StyledGrid
        alignItems="center"
        container
        direction="column"
        itemMargin="2rem"
        marginTop="4rem"
      >
        <StyledGrid item>
          <Title>404</Title>
        </StyledGrid>
        <StyledGrid item>
          <Subtitle>
            The BrainHealth App is temprarily unavailable due to scheduled
            maintenance
          </Subtitle>
        </StyledGrid>
        <StyledGrid item>
          <Paragraph>
            We appreciate your patience and look forward to welcoming you back
            soon
          </Paragraph>
        </StyledGrid>
        <StyledGrid
          item
          style={{
            marginTop: "auto",
            display: "flex",
            justifyContent: "center",
            maxWidth: "90%"
          }}
        >
          <ErrorImage style={{ maxWidth: "100%", height: "auto" }} />
        </StyledGrid>
      </StyledGrid>
    </>
  );
};

export default Maintenance;
